import { eyebrow } from "../../lib/ui.ts";

/**
 * The small uppercase kicker above a band's heading.
 *
 * Always a `<p>`, and deliberately not configurable. It used to take `as="h2"`,
 * which two bands used as their *only* heading — so the document outline had a
 * 0.74rem kicker standing in for a section head while the h3s beneath it
 * rendered three times larger, and /catalogue jumped from h1 straight to h3.
 * A kicker is a label, not a heading; the band's heading is the `<h2>` under it.
 */
export function Eyebrow({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <p className={className ? `${eyebrow} ${className}` : eyebrow}>{children}</p>;
}
